import { SimpleInputBaseDefinition, InputBaseComponent } from "components/input/baseInputDefinition";
import { InputComponent } from "components/components/Component";
import { ComponentActionHelper } from "components/events/componentActionHelper";
import { LabelElement } from "components/components/label/labelElement";
import { fireDataChangedEvent } from "components/form/dataChangedEventDetail";
import { OptionIterator } from "components/input/select/OptionIterator";
import { isOption, Optgroup, Option } from "components/input/select/options";
import { DoubleListSelectElement, initDoubleListInputWebComponent, OptionsInputFilter } from "./doubleListElement";
import { initDoubleListLeftSideWebComponent } from "./doubleListLeftSideElement";
import template from "./doubleListSelect.hbs";

initDoubleListLeftSideWebComponent();
initDoubleListInputWebComponent();

export class DoubleListSelectInput extends InputBaseComponent<DoubleListSelectInputDefinition> implements InputComponent {

    public readonly componentType: string = "doubleListSelectInput";

    private element: DoubleListSelectElement;
    private definitionOptions: Option[];


    constructor(schema: DoubleListSelectInputDefinition) {
        super(schema);
        this.definition.leftSideList = this.definition.leftSideList ?? true;
        if (this.definition.options != null) {
            this.definitionOptions = OptionIterator.filterFlat(this.definition.options, isOption);
        }
    }

    public render(): Element {
        this.renderTemplate();
        this.bindEvents();

        //Por si vienen definiciones en bundle
        this.addDefinitionOptions();

        ComponentActionHelper.register(this);
        return this.view;
    }

    private addDefinitionOptions() {
        if (this.definitionOptions != null && this.definitionOptions.length > 0) {
            this.element.options = this.definitionOptions;
        }
    }

    public renderTemplate(): Element {
        return super.renderTemplate(template);
    }

    private bindEvents(): void {

        this.element = this.view.querySelector("s6-double-list-input");

        this.element.addEventListener("change", () => {
            fireDataChangedEvent(this, this.view, this.getValue());
        });
    }

    public getValue(): Array<string | number> {
        return this.element.data;
    }

    public value(v: Array<string | number>) {
        this.element.data = v;
    }

    public setReadOnly(ro: boolean) {
        this.element.readOnly = ro;
    }

    public setRequired(required: boolean) {
        let inputLabel = this.view.querySelector("s6-input-label");
        if (inputLabel != null) {
            (inputLabel as LabelElement).required = required;
        }
    }

    public setValidationStatus(valid: boolean, message?: string) {
        this.element.valid = valid;
        this.element.validationMessage = message || null;
    }

    public addOptions(options: Option[]): void {
        if (options == null) {
            return;
        }
        if (this.definitionOptions == null) {
            this.definitionOptions = [];
        }
        this.definitionOptions = this.definitionOptions.concat(options);
        this.element.options = this.definitionOptions;
    }

    public setOptions(options: Option[]): void {
        this.definitionOptions = options;
        this.element.options = this.definitionOptions;
    }
}

export interface DoubleListSelectInputDefinition extends SimpleInputBaseDefinition {
    maxSelectable?: number;
    codeInOptionLabel?: boolean;
    options?: Array<Option | Optgroup>;

    leftSideList: boolean;
    doubleListOptionInputFilter?: OptionsInputFilter;
}
